import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Github, ExternalLink } from 'lucide-react';
import { projects } from '../data/mock';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';

const Projects = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const projectsPerView = 3;

  const nextSlide = () => {
    setCurrentIndex((prev) =>
      prev + projectsPerView >= projects.length ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? Math.max(0, projects.length - projectsPerView) : prev - 1
    );
  };

  const visibleProjects = projects.slice(
    currentIndex,
    currentIndex + projectsPerView
  );

  return (
    <section id="projects" className="section-padding">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Featured Projects</h2>
          <div className="section-underline"></div>
          <p className="section-description">
            A showcase of my work in backend development, AI/ML integration, and system architecture
          </p>
        </div>
        <div className="projects-carousel">
          <button
            onClick={prevSlide}
            className="carousel-button carousel-button-left"
            disabled={currentIndex === 0}
          >
            <ChevronLeft size={24} />
          </button>
          <div className="projects-wrapper">
            <div className="projects-grid">
              {visibleProjects.map((project) => (
                <Card key={project.id} className="project-card">
                  <div className="project-content">
                    <h3 className="project-title">{project.title}</h3>
                    <p className="project-description">{project.description}</p>
                    <div className="project-technologies">
                      {project.technologies.map((tech, idx) => (
                        <Badge key={idx} variant="secondary" className="tech-badge">
                          {tech}
                        </Badge>
                      ))}
                    </div>
                    <div className="project-links">
                      {project.github && (
                        <a
                          href={project.github}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="project-link"
                        >
                          <Github size={18} />
                          <span>Code</span>
                        </a>
                      )}
                      {project.demo && (
                        <a
                          href={project.demo}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="project-link"
                        >
                          <ExternalLink size={18} />
                          <span>Demo</span>
                        </a>
                      )}
                    </div>
                  </div>
                </Card>
              ))}
            </div>
          </div>
          <button
            onClick={nextSlide}
            className="carousel-button carousel-button-right"
            disabled={currentIndex + projectsPerView >= projects.length}
          >
            <ChevronRight size={24} />
          </button>
        </div>
        <div className="carousel-indicators">
          {Array.from({ length: Math.ceil(projects.length / projectsPerView) }).map((_, idx) => (
            <button
              key={idx}
              className={`indicator-dot ${
                Math.floor(currentIndex / projectsPerView) === idx ? 'active' : ''
              }`}
              onClick={() => setCurrentIndex(idx * projectsPerView)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;